var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "addressinfo userbox",
      attrs: { id: "addressinfo" }
    },
    [
      _c("div", { staticClass: "userTitle" }, [
        _vm._v(_vm._s(_vm.$t("ShippingAddresses")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "setaddressinfoBox" },
        [
          _vm.dislogType.address
            ? _c("to-address", {
                attrs: {
                  title: _vm.title,
                  domVisible: _vm.dislogType.address,
                  list: _vm.addressItem,
                  isSet: _vm.isSet
                },
                on: { closeDialog: _vm.closeDialog }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "userSetaddressinfo",
              on: {
                click: function($event) {
                  return _vm.setAddress("address", 0)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("AddNewAddress")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNull
        ? _c(
            "ul",
            { staticClass: "addressinfoList" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "li",
                { key: index, class: item.IsDefault ? "on" : "" },
                [
                  _c("div", { staticClass: "addresst" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("RecipientName")))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "addressText" }, [
                      _vm._v(_vm._s(item.UserName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "addresst" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("PhoneNumber")))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "addressText" }, [
                      _vm._v(_vm._s(item.Mobile))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "addresst" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("EmailAddress")))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "addressText" }, [
                      _vm._v(_vm._s(item.Email))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "addresst" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("Region")))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "addressText line_txt2" }, [
                      _vm._v(_vm._s(item.City))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "addresst" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("StreetAddress")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "addressText last_text line_txt2" },
                      [
                        _vm._v(
                          _vm._s(_vm._f("setProvice")(item.Provice)) +
                            " " +
                            _vm._s(item.AddressDetail)
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  item.IsDefault
                    ? _c("span", { staticClass: "default" }, [
                        _vm._v(_vm._s(_vm.$t("Default")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "setAddress",
                    on: {
                      click: function($event) {
                        return _vm.setAddress("address", 1, item)
                      }
                    }
                  }),
                  _vm._v(" "),
                  !item.IsDefault
                    ? _c(
                        "span",
                        {
                          staticClass: "defAddress",
                          on: {
                            click: function($event) {
                              return _vm.defAddress(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("MakePrimary")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !item.IsDefault
                    ? _c(
                        "span",
                        {
                          staticClass: "delAddress",
                          on: {
                            click: function($event) {
                              return _vm.delAddress(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Delete")))]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNull
        ? _c("nonull", {
            attrs: { type: "address", text: _vm.$t("NoSavedAddresses") }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-adea3f98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adea3f98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/address.vue
// module id = null
// module chunks = 